import HomePage from '@/pages/HomePage.vue';
import PostDetails from '@/pages/PostDetails.vue';
import AboutPage from '@/pages/AboutPage.vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import SectorPage from '@/pages/SectorPage.vue';
import NProgress from 'nprogress';
import NotFoundPage from '@/pages/NotFoundPage.vue';
import CategoryPage from '@/pages/CategoryPage.vue';
import LoginPage from '@/pages/auth/LoginPage.vue';
import RegisterPage from '@/pages/auth/RegisterPage.vue';
import ResetPasswordPage from '@/pages/auth/ResetPasswordPage.vue';
import UserPostsPage from '@/pages/UserPostsPage.vue';
import { useAuthStore } from '@/stores/auth';
import middlewarePipeline from './middlewarePipeline';
import auth from '@/middleware/auth';
import guest from '@/middleware/guest';
import ContributorsPage from '@/pages/ContributorsPage.vue';

const routes = [
  {
    name: 'Home',
    path: '/',
    component: HomePage,
  },
  {
    name: 'Contributors',
    path: '/contributors',
    component: ContributorsPage,
  },
  {
    name: 'About',
    path: '/about',
    component: AboutPage,
  },
  {
    name: 'Login',
    path: '/login',
    component: LoginPage,
    meta: {
      middleware: [guest]
    }
  },
  {
    name: 'Register',
    path: '/register',
    component: RegisterPage,
  },
  {
    name: 'Reset Password',
    path: '/reset-password',
    component: ResetPasswordPage,
  },
  {
    name: 'Sector',
    path: '/:sector',
    component: SectorPage,
  },
  {
    name: 'Category',
    path: '/:sector/:category',
    component: CategoryPage,
  },
  {
    name: 'BusinessDetails',
    path: '/:sector/:category/:business',
    component: PostDetails,
  },
  {
    name: 'UserBusinesses',
    path: '/users/:username/businesses',
    meta: {
      middleware: [auth],
    },
    component: UserPostsPage,
  },
  {
    name: 'UserBusinessSector',
    path: '/users/:username/:sector',
    meta: {
      middleware: [auth],
    },
    component: SectorPage
  },
  {
    name: 'UserBusinessCategory',
    path: '/users/:username/:sector/:category',
    meta: {
      middleware: [auth],
    },
    component: CategoryPage,
  },
  {
    name: 'UserBusinessDetails',
    path: '/users/:username/:sector/:category/:business',
    meta: {
      middleware: [auth],
    },
    component: PostDetails,
  },
  {
    name: 'NotFound',
    path: '/:pathMatch(.*)*',
    component: NotFoundPage,
  },
],

router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const authStore = useAuthStore();
  
  // If no middleware is required, just continue
  if (!to.meta.middleware) {
    // Only fetch user if not already authenticated and not in the process of authenticating
    if (!authStore.authUser && !authStore.loading) {
      await authStore.getAuthUser().catch(console.error);
    }
    return next();
  }

  const context = {
    to,
    from,
    next,
    stores: {
      auth: authStore,
    },
  };

  const { middleware } = to.meta;
  
  if (!middleware || !Array.isArray(middleware) || middleware.length === 0) {
    return next();
  }

  // Run the middleware pipeline
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
